// Key of the top-level "Création" tab in DocumentFormTabs (see tabItems, key: '1').
// This tab contains the widgets editing panel (WidgetsForm/WidgetCard):
// it must always be forced to display when highlighting a widget from the
// previewer, otherwise the highlight may happen on an invisible panel.
export const CREATE_TAB_KEY = '1';

// Computes, from a widget position in the previewer
// (format "sectionIndex-type-rowIndex-colIndex" injected by flexibranche-documents),
// the navigation target in the editor: section to display, DOM id to scroll to/highlight,
// and top-level tab to force.
const KNOWN_TYPES = ['content', 'header', 'footer'];

export const buildCardId = (sectionIndex, type, rowIndex) => `widget-card-${sectionIndex}-${type}-${rowIndex}`;

export const buildCardColId = (sectionIndex, type, rowIndex, colIndex) => `widget-card-col-${sectionIndex}-${type}-${rowIndex}-${colIndex}`;

export const getHighlightNavigationTarget = (position) => {
  const [sectionIndex, type, rowIndex, colIndex] = position.split('-');

  if (!KNOWN_TYPES.includes(type)) {
    console.warn(`getHighlightNavigationTarget: unknown widget type "${type}" in position "${position}", the scroll/highlight target may not match any DOM element`);
  }

  // The server sends 'content' for the document body, but the editor-side DOM
  // uses 'widgets' for that same type (see WidgetsForm.js / DocumentSections.js).
  const clientType = type === 'content' ? 'widgets' : type;

  return {
    sectionIndex,
    cardId: buildCardId(sectionIndex, clientType, rowIndex),
    cardColId: buildCardColId(sectionIndex, clientType, rowIndex, colIndex),
    mainTabKey: CREATE_TAB_KEY
  };
};
